export { default } from './ScrollToTop';



// WEBPACK FOOTER //
// ./src/components/common/ScrollToTop/index.js